import _styled from"@emotion/styled";import*as React from"react";import{Divider as HeroUIDivider}from"@heroui/react";const StyledDivider=_styled(HeroUIDivider)({"--tw-bg-opacity":"1","backgroundColor":"hsl(var(--nextui-divider) / var(--nextui-divider-opacity, var(--tw-bg-opacity)))"});const Divider=props=>React.createElement(StyledDivider,props);const DividerWrapper=_styled.div`
  ${{"marginTop":"1rem","marginBottom":"1rem","display":"flex","alignItems":"center"}}
  justify-content: ${({orientation})=>orientation==="left"?"flex-start":orientation==="right"?"flex-end":"center"};

  &:before,
  &:after {
    content: '';
    ${{"borderBottomWidth":"1px","--tw-border-opacity":"1","borderColor":"hsl(var(--nextui-divider) / var(--nextui-divider-opacity, var(--tw-border-opacity)))"}}
    flex: 1;
  }

  &:before {
    margin-right: ${({orientation})=>orientation==="left"?"0.5rem":"auto"};
    ${({orientation})=>orientation==="left"&&{"flex":"none"}};
  }

  &:after {
    margin-left: ${({orientation})=>orientation==="right"?"0.5rem":"auto"};
    ${({orientation})=>orientation==="right"&&{"flex":"none"}};
    padding-left: 0.5rem;
  }
`;const ChildrenWrapper=_styled.span`
  ${{"paddingLeft":"0.5rem","paddingRight":"0.5rem"}}
`;export const DividerWithChildren=({children,orientation="center"})=>React.createElement(DividerWrapper,{orientation:orientation},children?React.createElement(ChildrenWrapper,null,children):null);export default Divider;